import { NavLink } from '@mantine/core';
import type { ReactNode } from 'react';

/**
 * Shared sidebar row for the app shell and inner sidebars (Settings, design system).
 * Hover/active come from the theme NavLink tokens (`--nl-hover` / `--nl-bg`).
 */
export function UnifyNavLink({
  label,
  icon,
  href,
  active,
  onNavigate,
  rightSection,
  children,
  childrenOffset = 0,
}: {
  label: ReactNode;
  icon?: ReactNode;
  href?: string;
  active?: boolean;
  onNavigate?: () => void;
  rightSection?: ReactNode;
  children?: ReactNode;
  childrenOffset?: number;
}): JSX.Element {
  return (
    <NavLink
      label={label}
      href={href}
      leftSection={icon}
      rightSection={rightSection}
      active={active}
      childrenOffset={childrenOffset}
      onClick={
        onNavigate
          ? (e) => {
              e.preventDefault();
              onNavigate();
            }
          : undefined
      }
      mb={4}
    >
      {children}
    </NavLink>
  );
}
